import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import { usePermission } from '@/hooks/usePermission';
import { VISITAS_GESTAO, VISITAS_PORTAL } from './navItems';

const VisitasPainel = lazy(() => import('./Painel'));
const VisitasRegistrar = lazy(() => import('./Registrar'));
const VisitasAgenda = lazy(() => import('./Agenda'));
const VisitasHistorico = lazy(() => import('./Historico'));

/** Painel é da gestão; o corretor entra direto no Registrar. */
const VisitasInicio = () => {
    const { hasPermission } = usePermission();
    return hasPermission(VISITAS_GESTAO) ? <VisitasPainel /> : <Navigate to="/visitas/registrar" replace />;
};

export const visitasRoutes: RouteObject[] = [
    {
        path: '/visitas',
        element: (
            <ProtectedRoute anyOf={VISITAS_PORTAL}>
                <VisitasInicio />
            </ProtectedRoute>
        ),
    },
    {
        path: '/visitas/registrar',
        element: (
            <ProtectedRoute anyOf={VISITAS_PORTAL}>
                <VisitasRegistrar />
            </ProtectedRoute>
        ),
    },
    {
        path: '/visitas/agenda',
        element: (
            <ProtectedRoute permission={VISITAS_GESTAO}>
                <VisitasAgenda />
            </ProtectedRoute>
        ),
    },
    {
        path: '/visitas/historico',
        element: (
            <ProtectedRoute anyOf={VISITAS_PORTAL}>
                <VisitasHistorico />
            </ProtectedRoute>
        ),
    },
];
